import React from 'react';
import cls from 'classnames';
import { ModalWrapper } from '@/components';
import { Navigate, NavLink, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { ChangeAvatar, ChangeMessage, RoleSettings } from './settings';
import { ClanApplications } from './clan-applications';
import { useTranslation } from 'react-i18next';
import { useProfile } from '@/hooks';

function ClanSettings() {
  const { t } = useTranslation();

  const {
    profile: { clan },
  } = useProfile();

  const { pathname } = useLocation();
  const navigate = useNavigate();

  const guildId = React.useMemo(() => pathname.split('/')[2], [pathname]);

  if (clan?.id !== guildId /* TODO && clan?.role !== 'leader'*/)
    return <Navigate to={'/clans/' + guildId} />;

  return (
    <ModalWrapper open={true} auto={false} onClose={() => navigate('/clans/' + guildId)}>
      <div className='relative w-full lg:max-w-2xl flex flex-col sm:flex-row sm:divide-x divide-slate-200 gap-x-4'>
        <div className='flex flex-col basis-1/4 shrink-0'>
          <h2 className='text-xl leading-7 font-bold'>{t('Clan Settings')}</h2>
          <nav className='flex sm:flex-col my-4 sm:mt-8 gap-x-2 sm:gap-y-4'>
            <NavLink
              className={({ isActive }) =>
                cls(
                  'text-center sm:text-left w-full px-4 py-3 text-sm text-blue-500 rounded-lg transition-colors duration-150',
                  {
                    'bg-blue-50': isActive,
                  },
                )
              }
              to={'/clans/' + guildId + '/settings/message'}
            >
              {t('Message')}
            </NavLink>
            <NavLink
              className={({ isActive }) =>
                cls(
                  'text-center sm:text-left w-full px-4 py-3 text-sm text-blue-500 rounded-lg transition-colors duration-150',
                  {
                    'bg-blue-50': isActive,
                  },
                )
              }
              to={'/clans/' + guildId + '/settings/avatar'}
            >
              {t('Avatar')}
            </NavLink>
            {/* <NavLink
                className={({ isActive }) =>
                cls(
                'text-center sm:text-left w-full px-4 py-3 text-sm text-blue-500 rounded-lg transition-colors duration-150',
                {
                'bg-blue-50': isActive,
                },
                )
                }
                to={'/clans/' + guildId + '/settings/applications'}
                >
                {t('Applications')}
                </NavLink> */}
            <NavLink
              className={({ isActive }) =>
                cls(
                  'text-center sm:text-left w-full px-4 py-3 text-sm text-blue-500 rounded-lg transition-colors duration-150',
                  {
                    'bg-blue-50': isActive,
                  },
                )
              }
              to={'/clans/' + guildId + '/settings/roles'}
            >
              {t('Roles')}
            </NavLink>
          </nav>
        </div>
        <div className='flex-1 overflow-x-visible pl-4 h-auto sm:h-[580px]'>
          <Outlet />
        </div>
      </div>
    </ModalWrapper>
  );
}

ClanSettings.Message = ChangeMessage;
ClanSettings.Avatar = ChangeAvatar;
ClanSettings.Applications = ClanApplications;
ClanSettings.Roles = RoleSettings;

export default ClanSettings;
